import { render } from "./ModalContractsInfo.vue?vue&type=template&id=abbdfa52&scoped=true&ts=true"
import script from "./ModalContractsInfo.vue?vue&type=script&lang=ts"
export * from "./ModalContractsInfo.vue?vue&type=script&lang=ts"

import "./ModalContractsInfo.vue?vue&type=style&index=0&id=abbdfa52&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abbdfa52"]])

export default __exports__